import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconHomeLine: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconHomeLine"><Path d="M3.5 8.84247L12 2L20.5 8.84247V20.5H3.5V8.84247Z" stroke="currentColor" strokeLinecap="square"/><Path d="M6.5 17.5H17.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconHomeLine;
